/**
 * groupHistoryContainer.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import DOMPurify from "dompurify";

let curUserID = "";

DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  // set all elements owning target to target=_blank
  if (node.hasAttribute("target")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }

  if (node.tagName === "SPAN" && node.classList.contains("mention") &&
      !node.classList.contains("isMe")) {
    const user = node.getAttribute("data-member-id");
    if (user && (user === "all" || curUserID && user === curUserID)) {
      node.className += " isMe";
    }
  }
});

DOMPurify.setConfig({
  KEEP_CONTENT: false,
  ADD_ATTR: ["target"],
  FORBID_ATTR: ["style"],
  FORBID_TAGS: ["style"]
});

export function sanitize(str: string, userID?: string): string {
  if (userID) { curUserID = userID; }
  else { curUserID = ""; }

  return DOMPurify.sanitize(str);
}